import { Banner, Col, Picture, Row, Typography } from 'darrius';

interface IAboutCompanyProps {
  content: {
    title: string;
    description: string;
    descriptionImageOne: string;
    descriptionImageTwo: string;
    descriptionImageThree: string;
    descriptionImageFour: string;
  };
}

export const AboutCompany = (props: IAboutCompanyProps) => {
  const { content } = props;

  const defaultIconSize = {
    sm: {
      width: 42,
      height: 68,
    },
    md: {
      width: 106,
      height: 106,
    },
    lg: {
      width: 106,
      height: 106,
    },
  };

  return (
    <Banner
      as="section"
      size="2"
      title={content.title}
      text={content.description}
    >
      <Row className="space-top list">
        <Col className="col-sm-12 col-md-3 center-sm">
          <Picture
            src={{
              sm: `${process.env.NEXT_PUBLIC_ASSETS_PREFIX}/images/icons/celular-mobile.png`,
              md: `${process.env.NEXT_PUBLIC_ASSETS_PREFIX}/images/icons/celular.png`,
              lg: `${process.env.NEXT_PUBLIC_ASSETS_PREFIX}/images/icons/celular.png`,
            }}
            size={defaultIconSize}
            alt="celular"
          />
          <Typography.Text>{content.descriptionImageOne}</Typography.Text>
        </Col>
        <Col className="col-sm-12 col-md-3 center-sm">
          <Picture
            src={{
              sm: `${process.env.NEXT_PUBLIC_ASSETS_PREFIX}/images/icons/hand-mobile.png`,
              md: `${process.env.NEXT_PUBLIC_ASSETS_PREFIX}/images/icons/hand.png`,
              lg: `${process.env.NEXT_PUBLIC_ASSETS_PREFIX}/images/icons/hand.png`,
            }}
            size={defaultIconSize}
            alt="info"
          />
          <Typography.Text>{content.descriptionImageTwo}</Typography.Text>
        </Col>
        <Col className="col-sm-12 col-md-3 center-sm">
          <Picture
            src={{
              sm: `${process.env.NEXT_PUBLIC_ASSETS_PREFIX}/images/icons/moedas-mobile.png`,
              md: `${process.env.NEXT_PUBLIC_ASSETS_PREFIX}/images/icons/moedas.png`,
              lg: `${process.env.NEXT_PUBLIC_ASSETS_PREFIX}/images/icons/moedas.png`,
            }}
            size={defaultIconSize}
            alt="moedas"
          />
          <Typography.Text>{content.descriptionImageThree}</Typography.Text>
        </Col>
        <Col className="col-sm-12 col-md-3 center-sm">
          <Picture
            src={{
              sm: `${process.env.NEXT_PUBLIC_ASSETS_PREFIX}/images/icons/economia-mobile.png`,
              md: `${process.env.NEXT_PUBLIC_ASSETS_PREFIX}/images/icons/economia.png`,
              lg: `${process.env.NEXT_PUBLIC_ASSETS_PREFIX}/images/icons/economia.png`,
            }}
            size={defaultIconSize}
            alt="economia"
          />
          <Typography.Text>{content.descriptionImageFour}</Typography.Text>
        </Col>
      </Row>
    </Banner>
  );
};

export default AboutCompany;
